module.exports = __webpack_public_path__ + "img/indicadores.b159f977.svg";